// Central content for MH Étanchéité site
export const COMPANY = {
  name: "MH Étanchéité",
  address: "122 rue Rudolf Diesel",
  zip: "83600 Fréjus",
  phone: "0483938310",
  phoneDisplay: "04 83 93 83 10",
  email: "contact@mhenergy.fr",
  region: "Var • Alpes-Maritimes • PACA",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1622396481322-3b83d186701b?auto=format&fit=crop&w=1920&q=80",
  membrane: "https://images.unsplash.com/photo-1577572797100-d57f3c3aabff?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  terraceWork: "https://images.unsplash.com/photo-1680636861092-f49bb110d0d0?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  wall: "https://images.unsplash.com/photo-1579492450119-80542d516179?auto=format&fit=crop&w=1400&q=80",
  tiles: "https://images.unsplash.com/photo-1662557499709-a8d7ef6d7d5e?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  roofer: "https://images.unsplash.com/photo-1635424824800-692767998d07?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  terrace: "https://images.unsplash.com/photo-1630703103084-4ac45d397a0c?auto=format&fit=crop&w=1400&q=80",
  concrete: "https://images.pexels.com/photos/3882638/pexels-photo-3882638.jpeg?auto=compress&cs=tinysrgb&w=1400",
  tiles2: "https://images.unsplash.com/photo-1534503442463-e0ddba45cf4c?auto=format&fit=crop&w=1400&q=80",
};

export const SERVICES = [
  {
    id: "toiture",
    title: "Étanchéité toiture terrasse",
    desc: "Membrane bitumineuse, PVC ou résine appliquée dans les règles de l'art pour une toiture terrasse parfaitement étanche et durable.",
    img: IMAGES.membrane,
  },
  {
    id: "balcon",
    title: "Étanchéité balcon",
    desc: "Traitement des balcons et loggias contre les infiltrations : préparation du support, relevés et finitions soignées.",
    img: IMAGES.terrace,
  },
  {
    id: "murs",
    title: "Murs enterrés",
    desc: "Protection et cuvelage des murs enterrés et fondations contre les remontées d'humidité et les pressions hydrostatiques.",
    img: IMAGES.wall,
  },
  {
    id: "isolation",
    title: "Isolation thermique de toiture terrasse",
    desc: "Isolation performante de vos toitures terrasses pour réduire les déperditions énergétiques et améliorer votre confort.",
    img: IMAGES.roofer,
  },
  {
    id: "couvertine",
    title: "Pose de couvertine",
    desc: "Habillage et protection des acrotères par couvertines aluminium sur mesure : esthétique, étanche et sans entretien.",
    img: IMAGES.terraceWork,
  },
  {
    id: "dalles",
    title: "Pose de dalles sur plots",
    desc: "Création de terrasses techniques sur plots réglables : accessibilité de l'étanchéité, planéité parfaite, rendu haut de gamme.",
    img: IMAGES.tiles,
  },
  {
    id: "resine",
    title: "Résine d'étanchéité",
    desc: "Application de résine polyuréthane sur bassins, bacs et surfaces complexes : revêtement continu, sans joint et 100% étanche.",
    img: IMAGES.tiles,
  },
];

export const PROCESS = [
  { n: "01", title: "Diagnostic sur site", desc: "Nous nous déplaçons pour analyser votre support, identifier les sources d'infiltration et définir la solution adaptée." },
  { n: "02", title: "Devis gratuit détaillé", desc: "Un chiffrage clair et transparent, sans surprise, adapté à votre budget et aux contraintes de votre chantier." },
  { n: "03", title: "Réalisation experte", desc: "Une pose rigoureuse par nos étancheurs, avec des matériaux certifiés et le respect des DTU en vigueur." },
  { n: "04", title: "Garantie décennale", desc: "Vos travaux sont couverts par notre garantie décennale : sérénité totale pendant 10 ans." },
];

export const ZONES = [
  "Fréjus", "Saint-Raphaël", "Puget-sur-Argens", "Roquebrune-sur-Argens",
  "Cannes", "Mandelieu", "Saint-Tropez", "Nice", "Draguignan",
  "Var (83)", "Alpes-Maritimes (06)", "Toute la région PACA",
];

// Villes desservies (SEO local) — Var & Alpes-Maritimes
export const ALL_CITIES = [
  "Fréjus", "Saint-Raphaël", "Agay", "Anthéor", "Le Dramont", "Saint-Aygulf",
  "Les Issambres", "Puget-sur-Argens", "Roquebrune-sur-Argens", "Draguignan",
  "Le Muy", "Vidauban", "Fayence", "Callian", "Montauroux", "Bagnols-en-Forêt",
  "Saint-Paul-en-Forêt", "Tourrettes", "Saint-Tropez", "Sainte-Maxime", "Grimaud",
  "Cogolin", "Gassin", "Ramatuelle", "Cavalaire-sur-Mer", "La Croix-Valmer",
  "Cannes", "Le Cannet", "Mandelieu-la-Napoule", "Théoule-sur-Mer", "Mougins",
  "Pégomas", "Vallauris", "Antibes", "Juan-les-Pins", "Biot", "Villeneuve-Loubet",
  "Grasse", "Roquefort-les-Pins", "Valbonne", "Saint-Laurent-du-Var",
  "Cagnes-sur-Mer", "Nice",
];

export const TESTIMONIALS = [
  { name: "Jean-Marc P.", city: "Saint-Raphaël", text: "Étanchéité de notre toiture terrasse impeccable. Chantier propre, équipe ponctuelle et devis respecté à l'euro près." },
  { name: "Sophie L.", city: "Fréjus", text: "Enfin plus d'infiltrations sur le balcon ! Travail soigné et vrais conseils. Je recommande MH Étanchéité les yeux fermés." },
  { name: "Karim B.", city: "Cannes", text: "Pose de dalles sur plots sur notre terrasse : rendu haut de gamme et parfaitement de niveau. Un grand professionnalisme." },
];

export const STATS = [
  { value: "15+", label: "Années d'expérience" },
  { value: "10 ans", label: "Garantie décennale" },
  { value: "500+", label: "Chantiers réalisés" },
  { value: "100%", label: "Devis gratuits" },
];
